export default {
    key: 'employee-skipass',
    type: 'Activity',
    isUsingProductConfigPresets: false,
    disablePassengers: false,
    activityId: '9a8034fd-7e86-4787-856e-d6846e45d40a',
    categoryId: undefined,
    defaultDuration: undefined,
    isMultiDay: false,
    isUsingProductPresets: false,
    isUsingReductionCards: false,
    isUsingKeyCards: true,
    isUsingPromos: true,
    isPromotionRequired: true,
    showDuration: false,
    upsells: [],
    salesTimeLimit: undefined,
    isUpsellDatesRestricted: false,
    maxNumberOfPeople: undefined,
    maxNumberOfPeopleGroupTariff: undefined,
    isUsingSeasonDates: true,
    defaultPassengerAge: 30,
    hiddenProductReductionCard: undefined,
    listingId: '9a8034fd-7e86-4787-856e-d6846e45d40a',
    isLocalListing: false,
    steps: [
        {
            routeName: 'offerFlow-employee-skipass-steps-step-1-passengers',
            name: 'offerFlow.pages.stepPassengers.name.common',
        },
    ],
} satisfies ProductConfigActivity;
